import React, { useState } from "react";
import axios from "axios";
import "../Styling/InterViewSchedulingNavi1.css";

export default function InterviewScheduling() {
  const [form, setForm] = useState({
    type: "",
    name: "",
    date: "",
    time: "",
    mode: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  

  return (
    <div className="interviewScheduling-container">
      <h1>Verification and Interview Scheduling</h1>

      {/* Verification Panel */}

      <div className="panel">
        <div className="panel-title">
          <span className="bar"></span>
          Previous Company Verification
        </div>

        <div className="panel-body">
          <div className="verification-row">
            Verification Status
            <div className="verified">● Verified</div>
          </div>
        </div>
        
      </div>

      {/* Interview Panel */}

      <div className="panel">
        <div className="panel-title">
          <span className="bar"></span>
          Interview Scheduling
        </div>

        <div className="panel-body">
          <div className="grid">
            <div>
              <label>Interview Type</label>

              <select name="type" onChange={handleChange}>
                <option></option>

                <option>Technical</option>

                <option>HR</option>
              </select>
            </div>

            <div>
              <label>Interview Name</label>

              <select name="name" onChange={handleChange}>
                <option></option>

                <option>Round 1</option>

                <option>Round 2</option>
              </select>
            </div>

            <div>
              <label>Interview Date</label>

              <input type="date" name="date" onChange={handleChange} />
            </div>

            <div>
              <label>Interview Time</label>

              <input type="time" name="time" onChange={handleChange} />
            </div>

            <div className="full">
              <label>Interview Mode</label>

              <select name="mode" onChange={handleChange}>
                <option></option>

                <option>Online</option>

                <option>Offline</option>
              </select>
            </div>
          </div>   

        </div>
      </div>

      <div className="bottom-row">
        <div className="note">
          ● Invitation email sent automatically with local & UTC time
        </div>

        <button className="save-btn">Save & schedule Interview</button> 
      </div>
    </div>
  );
}
